export default __webpack_public_path__ + "static/media/hand.b3e4cb4d.png";